import { apiClient } from "@/api/axios";
import type { ApiResponse } from "@/types/api";
import type { InitData, InitRequest } from "@/types/init";
import type { DestinationData, DestinationRequest } from "@/types/destination";

export async function init(payload: InitRequest) {
  const { data } = await apiClient.post<ApiResponse<InitData>>(
    "/api/AgentBooking/init",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Failed retrieving init data");
  }

  return data;
}

export async function destination(payload: DestinationRequest) {
  const { data } = await apiClient.post<ApiResponse<DestinationData>>(
    "/api/AgentBooking/destination",
    payload,
  );

  if (!data.status) {
    throw new Error(data.message ?? "Failed retrieving destination data");
  }

  return data;
}